import { logoutUser } from "./logoutUser.function";

export function authErrorRedirect(response, history) {
  if (response === "Authentication required.") {
    history("/AccessDenied");
    return;
  }
  if (response === "Access denied.") {
    history("/AccessDenied");
    return;
  }
  if (response === "Invalid token.") {
    logoutUser(history);
    return;
  }
  if (response === "Invalid session.") {
    logoutUser(history);
    return;
  }

  return;
}
